import { Grid, Typography } from '@mui/material'
import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { Sidebar } from 'components/Sidebar'
import React, { PropsWithChildren, ReactNode } from 'react'
import { useWpAuthContext } from 'services/auth/WpAuthProvider'
import { getLocalStorageData } from 'utils/localStorage'
import { StyledAppContainer } from './styled'
import { StyledContainer } from 'components/Styled/styled'

type ContainerType = {
  title?: string
}

export const AppContainer: React.FC<PropsWithChildren<ContainerType>> = ({
  children,
  title
}) => {
  const { authUser } = useWpAuthContext()

  const userSessionData = getLocalStorageData('user_data')

  return (
    <StyledAppContainer>
      <Header />
      <StyledContainer>
        {title && (
          <Typography variant="h2" component="h1">
            {title}
          </Typography>
        )}
        {children}
      </StyledContainer>
      <Footer />
    </StyledAppContainer>
  )
}
